import { Component, ViewEncapsulation } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    standalone: false,
    selector: 'app-version',
    templateUrl: './app-version.component.html',
    encapsulation: ViewEncapsulation.None
})
export class AppVersionComponent {
    appVersion: string = environment.appVersion;
}